interface PaginacaoProps {
  paginaAtual: number;
  totalPaginas: number;
  onMudarPagina: (pagina: number) => void;
}

/**
 * Componente de paginação reutilizável. Usado em todas as listagens que
 * ultrapassam o limite de 10 registros por página (catálogo do usuário e
 * telas administrativas de Usuários, Livros, Categorias e Empréstimos).
 */
export function Paginacao({ paginaAtual, totalPaginas, onMudarPagina }: PaginacaoProps) {
  if (totalPaginas <= 1) return null;

  return (
    <div className="mt-6 flex items-center justify-center gap-2">
      <button
        onClick={() => onMudarPagina(paginaAtual - 1)}
        disabled={paginaAtual === 1}
        className="rounded-full px-3 py-1.5 text-xs font-bold text-muted hover:bg-surface-2 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Anterior
      </button>

      <span className="text-xs font-medium text-muted">
        Página {paginaAtual} de {totalPaginas}
      </span>

      <button
        onClick={() => onMudarPagina(paginaAtual + 1)}
        disabled={paginaAtual === totalPaginas}
        className="rounded-full px-3 py-1.5 text-xs font-bold text-muted hover:bg-surface-2 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Próxima
      </button>
    </div>
  );
}
